import apiConfig from 'http/services/api.config'
import apiService from 'http/services/api.service'
import {
  DetailedHealthResponse,
  UnauthorizedHealthResponse,
} from '../types/health-check-response'
import { HaioHttpResponse } from '../types/haio-http-response'

class HealthApiService {
  private readonly baseUrl: string

  constructor() {
    this.baseUrl = apiConfig.endpoints.health
  }

  /**
   * Performs a comprehensive health check of the system
   * Returns 200 if healthy, 503 if system unhealthy, 401 if user blocked
   */
  public async checkHealth(): Promise<
    DetailedHealthResponse | UnauthorizedHealthResponse
  > {
    return apiService.get<DetailedHealthResponse | UnauthorizedHealthResponse>(
      this.baseUrl
    )
  }

  /**
   * Restarts the HAIO stream
   * Returns 200 if successful, 400 if failed
   */
  public async restartStream(): Promise<HaioHttpResponse> {
    return apiService.get<HaioHttpResponse>(`${this.baseUrl}/restart-stream`)
  }

  /**
   * Stops the HAIO stream
   * Returns 200 if successful, 400 if failed
   */
  public async stopStream(): Promise<HaioHttpResponse> {
    return apiService.get<HaioHttpResponse>(`${this.baseUrl}/stop-stream`)
  }

  /**
   * Starts the HAIO stream
   * Returns 200 if successful, 400 if failed
   */
  public async startStream(): Promise<HaioHttpResponse> {
    return apiService.get<HaioHttpResponse>(`${this.baseUrl}/start-stream`)
  }

  /**
 * Clears HAIO cache
 * Returns 200 if successful, 400 if failed
 */
  public async clearCache(clientId: string): Promise<HaioHttpResponse> {
    return apiService.get<HaioHttpResponse>(`${this.baseUrl}/clear-cache/${clientId}`)
  }
}

export const healthApiService = new HealthApiService()
export default healthApiService
